export default {
  FETCH_BLOG_POST_COMMENTS_REQUEST: 'FETCH_BLOG_POST_COMMENTS_REQUEST',
  FETCH_BLOG_POST_COMMENTS_SUCCESS: 'FETCH_BLOG_POST_COMMENTS_SUCCESS',
  FETCH_BLOG_POST_COMMENTS_FAILURE: 'FETCH_BLOG_POST_COMMENTS_FAILURE',
  UPDATE_BLOG_POST_COMMENT_SENTIMENT: 'UPDATE_BLOG_POST_COMMENT_SENTIMENT'
}
